import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { AuthService } from '@card-software/nexus-utilities';
import { LotItemProxyService } from '../../../proxies/inventory/lot-item.proxy.service';
import { AdditionEntryType, LotItem } from '../../../models/inventory/lot-item';
import { InventorySearchCommand } from '../../../models/inventory-summary';
import { UserGroup } from '../../../models/authorization/enum/user-group.enum';

@Component({
  selector: 'app-merge-lot-items-list',
  templateUrl: './merge-lot-items-list.component.html',
  styleUrl: './merge-lot-items-list.component.scss',
})
export class MergeLotItemsListComponent implements OnInit {
  isLoading = 0;
  dataSource: LotItem[] = [];
  filtersForm: FormGroup;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private lotItemProxyService: LotItemProxyService,
  ) {
    this.filtersForm = this.formBuilder.group({
      lotItemNumber: [''],
    });
  }

  canEdit(): boolean {
    return AuthService.hasRole(UserGroup.MergeLotItemAdmin);
  }

  ngOnInit(): void {
    this.loadTableData();
  }

  loadTableData(): void {
    const lotItemNumber: string = this.filtersForm.value.lotItemNumber?.trim();
    const command: InventorySearchCommand = {
      hasMergeAdditions: true,
      lotItemNumbers: lotItemNumber ? [lotItemNumber] : undefined,
    };

    this.isLoading++;
    this.lotItemProxyService
      .batchSearch(command)
      .pipe(finalize(() => this.isLoading--))
      .subscribe({
        next: (res) => {
          this.dataSource = res.data ?? [];
        },
        error: (err) => {
          console.error('Error fetching merged lot items:', err);
        },
      });
  }

  resetFilters(): void {
    this.filtersForm.reset({ lotItemNumber: '' });
    this.loadTableData();
  }

  mergeCount(lotItem: LotItem): number {
    return (lotItem.additionEntries ?? []).filter((entry) => entry.type === AdditionEntryType.Merge).length;
  }

  mergedQuantity(lotItem: LotItem): number {
    return (lotItem.additionEntries ?? [])
      .filter((entry) => entry.type === AdditionEntryType.Merge)
      .reduce((sum, entry) => sum + Number(entry.quantity), 0);
  }

  lastMergeDate(lotItem: LotItem): Date | null {
    const dates = (lotItem.additionEntries ?? [])
      .filter((entry) => entry.type === AdditionEntryType.Merge)
      .map((entry) => new Date(entry.date).getTime());
    return dates.length > 0 ? new Date(Math.max(...dates)) : null;
  }

  redirectToDetail(id?: string): void {
    const queryParams = id ? { id } : {};
    this.router.navigate(['/merge-lot-items-details'], { queryParams });
  }
}
